// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { Environment } from '@nimmsta/ng-commons-lib/config';

export const environment = {
  production: false,
  environment: Environment.DEV,
  apiUrls: {
    b2b: 'https://backend.dev.b2b.nimmsta-test.de',
    workflow: 'https://backend.dev.cloud.nimmsta-test.de',
    configurations: 'https://backend.dev.configurator.nimmsta-test.de',
    auth: 'https://auth.dev.nimmsta-test.de',
  },
  applicationUrls: {
    workflow: 'https://dev.cloud.nimmsta-test.de',
    configurations: 'https://dev.configurator.nimmsta-test.de',
  },
  defaultPageSize: 20,
  defaultPageSizeOptions: [10, 20, 50, 100],
  keycloakUrl: 'https://auth.dev.nimmsta-test.de',
  keycloakRealm: 'productivity-cloud',
  keycloakClientId: 'platform',
  ncsTicketUrl: 'https://nimmsta.atlassian.net/browse',
  USER_KEY: 'user_object',
  defaultConfigurationVersion: 7,
};
